import template from './teamRequestCardDetails.html';
import controller from './teamRequestCardDetails.controller';
import './teamRequestCardDetails.scss';

let teamRequestCardDetailsComponent = {
  restrict: 'E',
  bindings: {
    request : '<',
    isDisabled: '<',
    isDisabledByDelegation: '<',
    showModalWarningDelegation: '&',
    isMobileApp: '<'
  },
  template,
  controller
};

export default teamRequestCardDetailsComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCardDetails.component.js